import { render, staticRenderFns } from "./RoleFormDialog.vue?vue&type=template&id=489e6e20&scoped=true&"
import script from "./RoleFormDialog.vue?vue&type=script&lang=js&"
export * from "./RoleFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoleFormDialog.vue?vue&type=style&index=0&id=489e6e20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e6e20",
  null
  
)

export default component.exports